export default __webpack_public_path__ + "static/media/Vector (2).273eaedc.svg";